import {
    FeedIncidentObj,
    FeedPostObj,
    FeedRepostObj,
    MarkFeedPostObj
} from "utils/types/general.types";

export const posts: FeedPostObj[] = [
    {
        id: "1",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "2",
        user: {
            id: 7,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "3",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "4",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "5",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "6",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "7",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 7,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "8",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 8,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "9",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "10",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "11",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "12",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "13",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "14",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "15",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "16",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "17",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 7,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "18",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 8,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "19",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "20",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "21",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    }
];

export const reposts: FeedRepostObj[] = [
    {
        id: "1",
        repostId: "25",
        repostedUser: {
            id: 6,
            name: "Satish Chauhan",
            username: "demo32",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
        },
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "2",
        repostId: "26",
        repostedUser: {
            id: 6,
            name: "Satish Chauhan",
            username: "demo32",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1706690469_profile.jpg"
        },
        user: {
            id: 7,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "3",
        repostId: "27",
        repostedUser: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "4",
        repostId: "28",
        repostedUser: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "5",
        repostId: "29",
        repostedUser: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    }
];

export const incidents: FeedIncidentObj[] = [
    {
        id: "1",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "2",
        location: "Somewhere in the world",
        user: {
            id: 2,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "3",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "4",
        location: "Somewhere in the world",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "5",
        location: "Somewhere in the world",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "6",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "7",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "8",
        location: "Somewhere in the world",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "9",
        location: "Somewhere in the world",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "10",
        location: "Somewhere in the world",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "11",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "12",
        location: "Somewhere in the world",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "13",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "14",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "15",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "16",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "17",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "18",
        location: "Somewhere in the world",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "19",
        location: "Somewhere in the world",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "20",
        location: "Somewhere in the world",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "21",
        location: "Somewhere in the world",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    }
];

export const hashtgaPosts: MarkFeedPostObj[] = [
    {
        id: "1",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "2",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "India",
        user: {
            id: 7,
            name: "shah rukh khan",
            username: "shahrukhkhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906495_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "3",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "4",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "5",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 4,
            name: "Momeento News",
            username: "momeento_news",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702232144674YmDJWZmUew.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "6",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "7",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 7,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "8",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 8,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "9",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 3,
            name: "Abdulaziz Al Khaldi",
            username: "azizalkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/17021226814932UWWDjndvg.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "10",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "11",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: true,
        hashtag: "Trending",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "12",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 1,
            name: "salman khan",
            username: "salmankhan",
            url: "https://momeento.nyc3.digitaloceanspaces.com/images/1702906284_profile.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 2,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "13",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 3,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "14",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "15",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 5,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "16",
        isIncident: true,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 6,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "17",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 7,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "18",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 8,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    },
    {
        id: "19",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 9,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "20",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 4,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: false,
        isSpam: false
    },
    {
        id: "21",
        isIncident: false,
        location: "somewhere in the world",
        isHashtag: false,
        hashtag: "India",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        text: "Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
        mediaType: 1,
        socialCount: {
            likes: 10,
            comments: 5,
            reposts: 3,
            views: 50
        },
        time: "July 26 2018, 01:03pm",
        isBlocked: true,
        isSpam: true
    }
];

export type PostReportObj = {
    id: string | number;
    title: string;
    desc: string;
    count: number;
    link: string;
};

export const postsReports: PostReportObj[] = [
    {
        id: 1,
        title: "Spam",
        desc: "Excessive mentions or replies",
        count: 2,
        link: "spam"
    },
    {
        id: 2,
        title: "Unwanted Sexual Content",
        desc: "Nudity or pornography not labeled",
        count: 1,
        link: "sexual"
    },
    {
        id: 3,
        title: "Copyright Violation",
        desc: "Contains copyrighted material",
        count: 4,
        link: "copyrights"
    },
    {
        id: 4,
        title: "Anti-Social Behavior",
        desc: "Harassment,trolling, or intolerance",
        count: 8,
        link: "anti-social"
    },
    {
        id: 5,
        title: "Illegal and Urgent",
        desc: "Glaring Violation of law or terms of service",
        count: 5,
        link: "illegal"
    },
    {
        id: 6,
        title: "Other",
        desc: "An issue not included in these options",
        count: 3,
        link: "others"
    }
];
